<template>
  <div class="media-box" :class="{ '-back': placement === 'back' }">
    <img
      v-if="mediaData.media.mediaType === 'image' && imageWidths === undefined"
      :class="'ratio-' + ratio"
      :src="appendCdnParams(mediaData.media.url)"
      :alt="mediaData.mediaAltText || ''"
      :loading="lazy ? 'lazy' : 'eager'"
      :style="mediaElStyles"
    />

    <img
      v-if="mediaData.media.mediaType === 'image' && imageWidths !== undefined"
      :class="'ratio-' + ratio"
      :src="appendCdnParams(mediaData.media.url)"
      :srcset="
        setImageSrcSet(
          mediaData.media.url,
          imageWidths.mobile,
          imageWidths.tablet,
          imageWidths.laptop,
          imageWidths.desktop,
        )
      "
      :sizes="
        setImageSizes(
          imageWidths.mobile,
          imageWidths.tablet,
          imageWidths.laptop,
          imageWidths.desktop,
        )
      "
      :alt="mediaData.mediaAltText || ''"
      :loading="lazy ? 'lazy' : 'eager'"
      :style="mediaElStyles"
    />

    <video
      v-if="mediaData.media.mediaType === 'video'"
      autoplay
      playsinline
      loop
      muted
      :src="mediaData.media.url"
      :style="mediaElStyles"
    />
  </div>
</template>

<script>
import { globalMethods } from "../../components/GlobalUI/mixins/global.js";

export default {
  name: "GlobalUIMedia",
  mixins: [globalMethods],
  props: {
    media: {
      type: Object,
      default() {
        return {};
      },
    },
    placement: {
      type: String,
      default: "back",
      validator(value) {
        return ["front", "back"].includes(value);
      },
    },
    imageWidths: {
      type: Object,
    },
    //only for cards
    ratio: {
      type: String,
      default: "",
    },
    lazy: {
      type: Boolean,
      default: false,
    },
    ignoreMediaStyles: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    mediaData() {
      return {
        mediaAltText: this.media.mediaAltText ?? "",
        media: this.media.media ?? this.media,
        corners: this.media.corners ?? null,
      };
    },
    mediaElStyles() {
      const { corners } = this.mediaData;
      if (!corners || this.ignoreMediaStyles) return {};

      const styles = {
        borderRadius:
          corners.value === "round"
            ? "var(--cr-border-radius-medium)"
            : "initial",
      };

      return styles;
    },
  },
};
</script>

<style lang="scss" scoped>
.media-box {
  overflow: hidden;
  height: 100%;
  width: 100%;

  &.-back {
    position: absolute;
    z-index: -1;
  }

  img,
  video {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
}
</style>
